import type { Router } from "expo-router";

import type { RemoteMessage } from "./messaging-service";
import { NotificationDataSchema } from "./types";

/**
 * Where tapping a notification lands, or `null` to stay put. Data this app
 * version doesn't understand — a newer `type`, or missing ids — parses to
 * `null` rather than throwing.
 */
export function notificationRoute(data: unknown): string | null {
  const parsed = NotificationDataSchema.safeParse(data);
  if (!parsed.success) return null;

  const { type, tenantId, siteId, cameraKey } = parsed.data;
  if (!tenantId || !siteId) return null;

  if (cameraKey) return `/tenants/${tenantId}/sites/${siteId}/cameras/${cameraKey}`;
  // A site-wide config change names no one camera, so it opens the site's
  // alarm settings, which is where the email for it links too.
  if (type === "camera_config_change") return `/tenants/${tenantId}/alarm-settings/${siteId}`;
  return null;
}

export function navigateToNotification(router: Router, message: RemoteMessage) {
  const route = notificationRoute(message.data);
  if (route !== null) router.push(route as never);
}
